export default "skymp5-front/aeac9f503e297b44561ace608450c517.webp";